module.exports = __webpack_public_path__ + "img/3.5ea55a43.png";